import { useMutation, useQuery } from '@tanstack/react-query';
import {
  getBuySells,
  createBuySell,
  updateBuySell,
  promoteBuySell,
  demoteBuySell,
  deleteBuySell,
  searchBuySellAccounts,
  sendBuySellStageEmail,
} from './buySellsApi';

export const createBuySellHooks = ({ queryClient }) => {
  const useBuySells = () =>
    useQuery({
      queryKey: ['buySells'],
      queryFn: getBuySells,
      keepPreviousData: true,
    });

  const useBuySellSearch = () =>
    useMutation({
      mutationFn: searchBuySellAccounts,
    });

  const useCreateBuySell = () =>
    useMutation({
      mutationKey: ['buySellCreate'],
      mutationFn: createBuySell,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['buySells'] });
      },
    });

  const useUpdateBuySell = () =>
    useMutation({
      mutationKey: ['buySellUpdate'],
      mutationFn: updateBuySell,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['buySells'] });
      },
    });

  const usePromoteBuySell = () =>
    useMutation({
      mutationFn: promoteBuySell,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['buySells'] });
      },
    });

  const useDemoteBuySell = () =>
    useMutation({
      mutationFn: demoteBuySell,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['buySells'] });
      },
    });

  const useDeleteBuySell = () =>
    useMutation({
      mutationFn: deleteBuySell,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['buySells'] });
      },
    });

  const useSendBuySellEmail = () =>
    useMutation({
      mutationFn: sendBuySellStageEmail,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['buySells'] });
      },
    });

  return {
    useBuySells,
    useBuySellSearch,
    useCreateBuySell,
    useUpdateBuySell,
    usePromoteBuySell,
    useDemoteBuySell,
    useDeleteBuySell,
    useSendBuySellEmail,
  };
};
